import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotfoundComponent } from '@shared/components/notfound/notfound.component';
import {NoPermissionComponent} from '@shared/components/no-permission/no-permission.component';

const routes: Routes = [
  {
    path: '404',
    component: NotfoundComponent,
    data: {
      config: 'notfound'
    }
  },
  {
    path: 'no-permission',
    component: NoPermissionComponent,
    data: {
      config: 'notfound'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }

